import { Buffer } from 'buffer'
if (!window.Buffer) window.Buffer = Buffer

import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { initSentry } from './lib/sentry'
import { initFeatureFailureListeners } from './lib/featureFailures'
import App from './App.tsx'
import './index.css'

initSentry();
initFeatureFailureListeners();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

// Retire the old service worker. Firebase Hosting already serves hashed assets
// with immutable caching and no-cache HTML; an app-shell SW can serve stale UI.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => {});

    if ('caches' in window) {
      caches.keys()
        .then((keys) => Promise.all(keys.filter((key) => key.startsWith('rc-')).map((key) => caches.delete(key))))
        .catch(() => {});
    }
  });
}
